import * as React from "react";
import {AnnualPolicyInfo, D_MMM_YYYY_DATE_FORMAT, INTERACTION_PROCESS_MTC_LV, Policy } from "@ferry/journey-services";
import { WarningBanner } from "@ferry/portal-core";
import * as moment from "moment/moment";

interface IProps {
    policy: Policy;
    process: string;
}

export class CancellationBanner extends React.Component<IProps> {

    public render() {
        const annualPolicyInfo: AnnualPolicyInfo = this.props.policy.annualPolicyInfo;

        if (annualPolicyInfo?.missedAnnualPaymentInfo || annualPolicyInfo?.delinquencyStartDate) {
            return this.renderMissedPaymentCancellationBanner(annualPolicyInfo);
        } else {
            return this.renderRegularCancellationBanner();
        }
    }

    private renderMissedPaymentCancellationBanner(annualPolicyInfo: AnnualPolicyInfo): React.ReactNode {
        const now: moment.Moment = moment();
        const missedAnnualPaymentInfo = annualPolicyInfo.missedAnnualPaymentInfo;
        const cancellationDate: moment.Moment = moment.utc(this.props.policy.endDate, moment.ISO_8601);
        const formattedCancellationDate: string = cancellationDate.format(D_MMM_YYYY_DATE_FORMAT);

        let initialPaymentDate;

        if (missedAnnualPaymentInfo) {
            initialPaymentDate = moment(missedAnnualPaymentInfo?.invoiceDueDate).format(D_MMM_YYYY_DATE_FORMAT);
        } else if (annualPolicyInfo.delinquencyStartDate) {
            initialPaymentDate = moment(annualPolicyInfo.delinquencyStartDate).format(D_MMM_YYYY_DATE_FORMAT);
        }

        if (initialPaymentDate && (this.props.process === INTERACTION_PROCESS_MTC_LV || now.isAfter(cancellationDate))) {
            return (
                <WarningBanner id="cancellationDate" wording={
                    <>
                        We've been in touch with you number of times since{' '}
                        <span className="font-weight-bold">{initialPaymentDate}</span>{' '}
                        because we didn't receive your payment.{' '}
                        Your cover ended on <span className="font-weight-bold">{formattedCancellationDate}, 23:59.</span>
                    </>
                }/>
            )
        }

        return <></>
    }

    private renderRegularCancellationBanner(): React.ReactNode {
        let wording: string;
        const endDate: moment.Moment = moment.utc(this.props.policy.endDate, moment.ISO_8601);

        if (endDate.isBefore(moment(), 'day')) {
            wording = `Your car policy was cancelled on ${endDate.format(D_MMM_YYYY_DATE_FORMAT)}, 23:59.`;
        } else {
            wording = `Your car policy will end on ${endDate.format(D_MMM_YYYY_DATE_FORMAT)}, 23:59. Until then you are still covered`;
        }

        return (
            <WarningBanner wording={wording}/>
        );
    }
}
